(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-light"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = matchMedia('(max-width: 749px)');
    const saveData = navigator.connection && navigator.connection.saveData;

    // Keep the sparkles on the jewelry: convert image-relative % to box-relative % under object-fit: cover.
    function placeSparks(root) {
      const img = root.querySelector('img.mlh__still');
      const box = root.querySelector('.mlh__frame');
      if (!img || !img.naturalWidth || !box) return;
      const cs = getComputedStyle(root);
      const m = mobile.matches;
      const fx = parseFloat(cs.getPropertyValue(m ? '--sx-m' : '--sx-d')) / 100;
      const fy = parseFloat(cs.getPropertyValue(m ? '--sy-m' : '--sy-d')) / 100;
      const W = box.clientWidth, H = box.clientHeight, iw = img.naturalWidth, ih = img.naturalHeight;
      const s = Math.max(W / iw, H / ih);
      const x = (W - iw * s) / 2 + fx * iw * s, y = (H - ih * s) / 2 + fy * ih * s;
      root.style.setProperty('--px', ((x / W) * 100).toFixed(2));
      root.style.setProperty('--py', ((y / H) * 100).toFixed(2));
    }

    function startVideo(root) {
      const v = root.querySelector('.mlh__video');
      if (!v || reduce.matches || saveData) return;
      const src = mobile.matches ? v.dataset.srcMobile : v.dataset.srcDesktop;
      if (!src) return;
      if (v.getAttribute('src') !== src) v.src = src;
      v.addEventListener('playing', () => root.classList.add('is-video'), { once: true });
      const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { v.play().catch(() => {}); } else { v.pause(); } });
      io.observe(root);
    }

    function init(root) {
      if (root.dataset.mlhReady) return;
      root.dataset.mlhReady = '1';
      const img = root.querySelector('img.mlh__still');
      const place = () => placeSparks(root);
      if (img) { img.complete ? place() : img.addEventListener('load', place); img.addEventListener('load', place); }
      addEventListener('resize', place, { passive: true });
      mobile.addEventListener('change', place);
      const go = () => ('requestIdleCallback' in window ? requestIdleCallback(() => startVideo(root), { timeout: 2500 }) : setTimeout(() => startVideo(root), 800));
      document.readyState === 'complete' ? go() : addEventListener('load', go, { once: true });
      reduce.addEventListener('change', () => { const v = root.querySelector('.mlh__video'); if (v && reduce.matches) { v.pause(); root.classList.remove('is-video'); } });
    }

    const run = () => document.querySelectorAll('[data-mlh]').forEach(init);
    run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
